export interface XlsxSheet {
  name: string;
  rows: Record<string, unknown>[];
  headers?: string[];
}

export async function downloadXlsx(
  filename: string,
  sheets: XlsxSheet[],
): Promise<void> {
  const XLSX = await import("xlsx");
  const wb = XLSX.utils.book_new();
  sheets.forEach((sheet) => {
    const ws = sheet.headers
      ? XLSX.utils.json_to_sheet(sheet.rows, { header: sheet.headers })
      : XLSX.utils.json_to_sheet(sheet.rows);
    // Truncate sheet name to Excel's 31-char limit.
    const safeName = sheet.name.slice(0, 31);
    XLSX.utils.book_append_sheet(wb, ws, safeName);
  });
  XLSX.writeFile(wb, filename);
}
